import dayjs from 'dayjs';

/**
 * Formatuje ISO datetime string (z backendu) do ceskeho formatu dd.MM.yyyy HH:mm:ss.
 * Vraci '—' pro null/undefined.
 */
export function formatCzechDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return dayjs(iso).format('DD.MM.YYYY HH:mm:ss');
}

/**
 * Formatuje jen cas HH:mm:ss (pro kompaktni zobrazeni v tabulce).
 */
export function formatCzechTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return dayjs(iso).format('HH:mm:ss');
}
